import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import HText from 'components/CText/HText';
import { Button } from 'components/form/Button/Button';
import Label from 'components/form/Label/Label';
import ApprovalOddsBadge from 'components/Offers/fragments/ApprovalOddsBadge/index';
import { ReactComponent as OpenInNew } from 'style_icons/open-in-new-blue.svg';

import './GlossyCreditCardOffer.scss';
import AmexWithConfidence from 'components/Offers/AmexWithConfidence/AmexWithConfidence';

export const GlossyCreditCardOffer = props => {
  const {
    offerMetadata,
    offerImageLinkUrlProxy,
    clickApplyImageHandler,
    clickApplyHandler,
    clickDetailsHandler,
    buttonLabel,
    seenPixel,
    clickApplyCardNameHandler,
    clickTcHandler,
    showApprovalOddsBadge,
  } = props;

  return (
    <>
      {seenPixel}
      <FlexContainer className="glossyCreditCardOffer flex-column gap-10 pad24 margB12 padT0">
        <FlexContainer className="m-flex-column items-align-center flex-1 justify-between gap-16 m-margB12">
          <img
            alt="credit card"
            onClick={e => {
              e.stopPropagation();
              clickApplyImageHandler(e);
            }}
            src={offerImageLinkUrlProxy}
            className="imgCreditCard borderRadius3 borderwhite pointer"
          />
          <FlexContainer className="flex-column gap-16 width100 items-align-center">
            <Button
              rounded
              mrphType="primary"
              className="applyButton"
              onClick={e => {
                e.stopPropagation();
                clickApplyHandler(e);
              }}
            >
              <FlexContainer className="justify-center align-items-center marglr10 m-marglr0 text-16">
                {buttonLabel}
              </FlexContainer>
            </Button>

            <Label
              type="Subtitle-3"
              color="secondary_text_light"
              className="Body-2 otherLink width100 height16px text-center notBold"
              onClick={e => {
                e.stopPropagation();
                clickDetailsHandler(e);
              }}
            >
              View Details
            </Label>
          </FlexContainer>
        </FlexContainer>
        {props?.showAmexWithConfidence && <AmexWithConfidence />}

        <FlexContainer className="flex-column gap-4">
          <FlexContainer className="flex-column items-align-start pointer">
            <HText
              className="Subtitle-2 secondary_text_light"
              html={offerMetadata?.name}
              onKeyDown={clickApplyCardNameHandler}
              onClick={e => {
                e.stopPropagation();
                clickApplyCardNameHandler(e);
              }}
            />
          </FlexContainer>
          <FlexContainer className="flex justify-between items-align-center m-items-align-start gap-20">
            <FlexContainer className="flex-column items-align-left format60 pointer">
              <Label className="Subtitle-3 system_neutral_n400_text text-13">
                <span className="bold">Annual Fee: </span>
                <span>{offerMetadata?.annualFeeDetails}</span>
              </Label>
              <Label className="Subtitle-3 system_neutral_n400_text text-13">
                <span className="bold">Regular APR: </span>
                <span>{offerMetadata?.aprDetails}</span>
              </Label>
            </FlexContainer>
            {!showApprovalOddsBadge && (
              <ApprovalOddsBadge
                offerMetadata={offerMetadata}
                labelCustomClass="system_neutral_n400_text text-12 text-center"
                isTooltipSorrounded
                isRedesignCard
              />
            )}
          </FlexContainer>
          <FlexContainer className="m-margTB10">
            {offerMetadata?.tcUrl && (
              <a
                className={'flex-container items-align-center margT4'}
                onClick={e => {
                  e.stopPropagation();
                  clickTcHandler(e);
                }}
                href={offerMetadata?.tcUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Label
                  type="Subtitle-2"
                  color="primary_text_light"
                  className="link notBold text-12"
                >
                  {offerMetadata?.tcText}
                </Label>
                <OpenInNew className="margL4" />
              </a>
            )}
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </>
  );
};
